import React, { useState } from 'react';
import HelpModal, { HelpText } from './HelpModal';

interface HelpIconProps {
    helpText: HelpText;
    fieldLabel?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ helpText, fieldLabel }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isPressed, setIsPressed] = useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsModalOpen(true);
    };

    const buttonStyle: React.CSSProperties = {
        background: isHovered ? '#e9e9e9' : '#f4f4f4',
        border: '1px solid #ccc',
        cursor: 'pointer',
        padding: 0,
        marginLeft: 8,
        color: '#333',
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: 1,
        borderRadius: '50%',
        width: 22,
        height: 22,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.1s ease-in-out',
        userSelect: 'none',
        transform: isPressed ? 'scale(0.95)' : 'scale(1)',
        boxShadow: isHovered ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
        outline: 'none',
    };

    return (
        <>
            <button
                type="button"
                onClick={handleClick}
                style={buttonStyle}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => {
                    setIsHovered(false);
                    setIsPressed(false);
                }}
                onMouseDown={() => setIsPressed(true)}
                onMouseUp={() => setIsPressed(false)}
                title="Click for help"
            >
                ?
            </button>

            <HelpModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                helpText={helpText}
                title={fieldLabel ? `Help: ${fieldLabel}` : "Help"}
            />
        </>
    );
};

export default HelpIcon;